/// <amd-module name="Core/Medius.Core.Web/Scripts/components/taskHandling/shared/tabsCollection/fullScreenModeSide"/>
export enum FullScreenModeSide {
    Left = "left",
    Right = "right"
}
